import {ADD_CATEGORY, REMOVE_CATEGORY, RESET_FILTER, SET_FILTER, SET_ORDER_TYPE} from '../actions/actionTypes';

const INITIAL_STATE = { filter: null, categories: [], orderType: 0 };
let newCategories;

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_FILTER:
            let newFilter = action.payload;

            if (state.filter === action.payload) {
                newFilter = null;
            }

            return { ...state, filter: newFilter };

        case ADD_CATEGORY:
            newCategories = [...state.categories];
            newCategories.push(action.payload);
            return { ...state, categories: newCategories };

        case REMOVE_CATEGORY:
            newCategories = state.categories.filter(i => {
                return i != action.payload;
            });

            return { ...state, categories: newCategories };

        case SET_ORDER_TYPE:
            return { ...state, orderType: action.payload };
        case RESET_FILTER:
            return { ...INITIAL_STATE };

        default:
            return state;
    }
}
